import api from 'services/api';
import { POST, authRoutes } from 'constants/api';

export const logout = () => Promise.resolve({ success: true });

export const googleLogin = ({ idToken }) =>
  api({
    method: POST,
    url: authRoutes.GOOGLE_LOGIN,
    withoutAuthorization: true,
    data: { idToken },
  });
